import { render, staticRenderFns } from "./formerstudents.vue?vue&type=template&id=5b0fa86e&scoped=true"
import script from "./formerstudents.vue?vue&type=script&lang=js"
export * from "./formerstudents.vue?vue&type=script&lang=js"
import style0 from "./formerstudents.vue?vue&type=style&index=0&id=5b0fa86e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0fa86e",
  null
  
)

export default component.exports